import React, { Component } from 'react';
import { msalApp, requiresInteraction, ONP_CONSENT_LOGIN_REQUESTS } from './';
import { WindowUtils } from 'msal';
import { msalErrorMessage_AADB2C90077, msalErrorMessage_AADB2C90118, useRedirectFlow } from '../constants';
import { REACT_APP_REDIRECT_URI } from '../config';

const redirectUri = REACT_APP_REDIRECT_URI;

const getMSalToken = async (request, redirect) => {
  return msalApp.acquireTokenSilent(request).catch((error) => {
    // Call acquireTokenPopup (popup window) in case of acquireTokenSilent failure
    // due to consent or interaction required ONLY
    if (requiresInteraction(error.errorCode) || error.errorMessage.includes(msalErrorMessage_AADB2C90077)) {
      return redirect ? msalApp.acquireTokenRedirect({ ...request, redirectUri }) : msalApp.acquireTokenPopup(request);
    } else {
      console.error('Non-interactive error:', error);
      return null;
    }
  });
};

const AuthProvider = (C) =>
  class Provider extends Component {
    constructor(props) {
      super(props);
      this.state = {
        account: undefined,
        error: undefined,
        accessToken: undefined,
        redirecting: false,
        loading: false,
        tokenResp: null,
      };
    }

    async acquireToken(request, redirect) {
      this.setState({ loading: true });
      return getMSalToken(request, redirect);
    }

    async onSignIn(redirect) {
      if (redirect) {
        const acct = msalApp.getAccount();
        this.setState({ loading: true });
        if (!acct) {
          msalApp.loginRedirect(ONP_CONSENT_LOGIN_REQUESTS.LOGIN);
        }
        return true;
      }
      return false;
    }

    onSignOut() {
      msalApp.logout();
    }

    handleValidationAfterLogin(accessToken) {
      console.log('handleValidationAfterLogin');
    }

    async componentDidMount() {
      msalApp.handleRedirectCallback((error) => {
        this.setState({ loading: false });
        if (error) {
          const errorMessage = error.errorMessage
            ? error.errorMessage
            : 'Unable to acquire access token. Attempting loginRedirct...';
          // setState works as long as navigateToLoginRequestUrl: false
          this.setState({ error: errorMessage });
          if (typeof error.errorMessage === 'string' && error.errorMessage.indexOf(msalErrorMessage_AADB2C90118) > -1) {
            this.setState({ redirecting: true });
            try {
              msalApp.loginRedirect(ONP_CONSENT_LOGIN_REQUESTS.LOGIN);
            } catch (err) {
              this.setState({ redirecting: false, error: err });
            }
          }
        }
      });
      const account = msalApp.getAccount();
      if (account && !WindowUtils.isInIframe()) {
        const tokenResponse = await this.acquireToken(ONP_CONSENT_LOGIN_REQUESTS.LOGIN, useRedirectFlow);
        if (tokenResponse) {
          this.handleValidationAfterLogin(tokenResponse.idToken);
          this.setState({
            account,
            accessToken: tokenResponse.idToken,
            tokenResp: tokenResponse,
          });
          localStorage.setItem('account', JSON.stringify(this.state.account));
          localStorage.setItem('accessToken', JSON.stringify(tokenResponse.idToken));
        }
      } else {
        this.setState({
          account: localStorage.getItem('account'),
          accessToken: localStorage.getItem('accessToken'),
        });
        this.setState({ account: undefined });
      }
      this.setState({ loading: false });
    }

    render() {
      return (
        <C
          {...this.props}
          account={this.state.account}
          error={this.state.error}
          tokenResp={this.state.tokenResp}
          accessToken={this.state.accessToken}
          onSignIn={() => this.onSignIn(useRedirectFlow)}
          onSignOut={() => this.onSignOut()}
          redirecting={this.state.redirecting}
          loading={this.state.loading}
        />
      );
    }
  };

export default AuthProvider;
